import { useIsLight } from '@gef-ui/material-theme-utils/hooks';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { colorPropType } from '../../hooks/useThemeColor';
import GcpLion from '../Logo/GcpLion';
import { passSx, sxPropType } from '../utils';
const StyledLion = styled(GcpLion)(()=>({
        width: '70%'
    }));
const GcpProgress = ({ size = 100, color = 'primary', sx })=>{
    const isLight = useIsLight();
    return /*#__PURE__*/ React.createElement(Box, {
        sx: [
            {
                position: 'relative',
                display: 'inline-flex'
            },
            ...passSx(sx)
        ]
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        sx: (theme)=>theme.applyStyles('dark', {
                color: `${color}.contrastText`
            }),
        size: size,
        color: color
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(StyledLion, {
        color: isLight ? color : `${color}.contrastText`
    })));
};
GcpProgress.propTypes = {
    color: colorPropType,
    size: PropTypes.number,
    sx: sxPropType
};
export default GcpProgress;
